import React from 'react'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import AdTikTokCreateForm from './AdTikTokCreateForm'
import SkeletonForm from '../../../../components/Form/Skeleton'

import { lineItemErrorSelector, lineItemWasLoadedSelector } from '../../../../modules/selectors/lineItems'

import { AD_TIKTOK_CREATE } from '../../../../constants/forms'

function AdTikTokCreate() {
  const lineItemWasLoaded = useSelector(lineItemWasLoadedSelector)
  const lineItemError = useSelector(lineItemErrorSelector)

  if (lineItemError) {
    return null
  }

  return (
    <FormDrawerWrapper
      formName={AD_TIKTOK_CREATE}
      openButtonText="Create Ad"
      isFormLoading={!lineItemWasLoaded}
      SkeletonFormComponent={SkeletonForm}
    >
      <AdTikTokCreateForm />
    </FormDrawerWrapper>
  )
}

export default AdTikTokCreate
